<template>
  <div class="broadcast-page">
    <div class="broadcast-header">
      <el-button icon="el-icon-arrow-left" circle size="mini" @click="goBack"></el-button>
      <span class="broadcast-header-title">广播服务</span>
    </div>
    <div class="broadcast-body" v-loading="loading" element-loading-text="加载中...">
      <div v-if="!loading && broadcastList.length === 0" class="empty-tip">暂无广播消息</div>
      <div v-else class="broadcast-list">
        <div
          v-for="item in broadcastList"
          :key="item.id"
          class="broadcast-row"
          @click="openDetail(item)"
        >
          <div class="row-icon">
            <i class="el-icon-message-solid"></i>
          </div>
          <div class="row-main">
            <div class="row-title">{{ item.title }}</div>
            <div class="row-content">{{ getPlainText(item.content) }}</div>
          </div>
          <div class="row-meta">
            <span>{{ formatTime(item.releaseTime) }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listAllPublicMsgs } from "../api/publicMsg";

export default {
  name: "BroadcastList",
  data() {
    return {
      broadcastList: [],
      loading: false
    };
  },
  mounted() {
    this.loadBroadcastList();
  },
  methods: {
    loadBroadcastList() {
      this.loading = true;
      listAllPublicMsgs()
        .then((result) => {
          this.broadcastList = Array.isArray(result) ? result : [];
        })
        .catch(() => {
          this.$message.error("加载广播消息失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetail(item) {
      this.$router.push(`/home/broadcast/${item.id}`);
    },
    goBack() {
      this.$router.push("/home/chat");
    },
    formatTime(timeStr) {
      if (!timeStr) return "-";
      const date = new Date(timeStr);
      if (Number.isNaN(date.getTime())) return "-";
      const pad = (value) => String(value).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    getPlainText(htmlContent) {
      if (!htmlContent) return "";
      let text = String(htmlContent)
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/\s+/g, " ")
        .trim();
      return text.length > 90 ? `${text.substring(0, 90)}...` : text;
    }
  }
};
</script>

<style scoped lang="scss">
.broadcast-page {
  height: 100%;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.broadcast-header {
  height: 50px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
  box-sizing: border-box;
}

.broadcast-header-title {
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.broadcast-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px;
  box-sizing: border-box;
}

.broadcast-list {
  max-width: 860px;
  margin: 0 auto;
}

.broadcast-row {
  display: flex;
  align-items: center;
  min-height: 82px;
  padding: 14px 16px;
  margin-bottom: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  box-sizing: border-box;
}

.broadcast-row:hover {
  border-color: #f59e0b;
}

.row-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f59e0b;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.row-main {
  flex: 1;
  min-width: 0;
  padding-left: 14px;
}

.row-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row-content {
  margin-top: 6px;
  font-size: 13px;
  color: #6b7280;
  line-height: 20px;
}

.row-meta {
  min-width: 130px;
  padding-left: 12px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 12px;
  flex-shrink: 0;
}

.empty-tip {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}
</style>
